import { useEffect, useState } from "react";
import { useAuth } from "../../../authentication";
import { postApi, putApi, getApi } from "../../Axios";
import { getApi as newGetApi, postApi as newPostApi } from "../../Axios_Dev";
import { httpClient } from "../../Api";
import { message } from "antd";

export const useEmployee = () => {
  const { getLogout } = useAuth();
  const [allEmployeesData, setAllEmployeesData] = useState([]);

  const getData = () => {
    getAllEmployees(0, (data) => {
      setAllEmployeesData(data);
    });
  };

  const getEmployee = (callbackFun) => {
    getApi(`EmployeeReg`, callbackFun, "data", getLogout, false);
  };

  const getDesignation = (LookupType, PType, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetHsptlLookup/${LookupType},${PType}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getGender = (LookupType, PType, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetHsptlLookup/${LookupType},${PType}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getMaritalStatus = (LookupType, PType, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetHsptlLookup/${LookupType},${PType}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getBloodGroup = (LookupType, PType, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetHsptlLookup/${LookupType},${PType}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getReligion = (LookupType, PType, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetHsptlLookup/${LookupType},${PType}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getCountries = (callbackFun) => {
    newGetApi(`Pharmacy/LookUps/GetCountries`, callbackFun, "data", false);
  };

  const getState = (CountryId, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetStates/${CountryId}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getCities = (CountryId, StateId, callbackFun) => {
    newGetApi(
      `Pharmacy/LookUps/GetCities/${CountryId},${StateId}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getAllEmployees = (EmpId, callbackFun) => {
    newGetApi(
      `EmployeeReg/GetAllEmployees/${EmpId}`,
      callbackFun,
      "data",
      false,
    );
  };

  const getEmployeeDetail = (EmpId, callbackFun) => {
    newGetApi(
      `EmployeeReg/GetEmployeeDetail/${EmpId}`,
      callbackFun,
      "data",
      false,
    );
  };

  const addEmployee = (employee, callbackFun) => {
    postApi(`EmployeeReg`, employee, callbackFun, "msg", getLogout, true);
  };

  const updateEmployee = (employee, callbackFun) => {
    putApi(`EmployeeReg`, employee, callbackFun, "msg", getLogout, true);
  };

  const getEmployeePromise = (HsptID, DeptID, SubDeptID, callbackFun) => {
    getApi(
      `DefaultMethods/DefaultMethods?Type=Employee&HsptID=${HsptID}&DeptID=${DeptID}&SubDeptID=${SubDeptID}`,
      callbackFun,
      "data",
      getLogout,
      false,
    );
  };

  const getDoctorPromise = (HsptID, DeptID, SubDeptID, callbackFun) => {
    getApi(
      `DefaultMethods/DefaultMethods?Type=Doctors&HsptID=${HsptID}&DeptID=${DeptID}&SubDeptID=${SubDeptID}`,
      callbackFun,
      "data",
      getLogout,
      false,
    );
  };

  const getPatientVisits = (
    fromDate,
    toDate,
    visitType,
    DocID,
    callbackFun,
  ) => {
    newGetApi(
      `PatientMenu/PatientRegistr/GetPatientVisits/${fromDate},${toDate},${visitType},${DocID}`,
      callbackFun,
      "data",
      getLogout,
      false,
    );
  };

  const onUpdateEmployee = (payload, callbackFun) => {
    upsertEmployee(payload, (msg) => {
      getData();
      message.success(<span>{msg}</span>);
      callbackFun && callbackFun();
    });
  };

  const upsertEmployee = (payload, callbackFun) => {
    newPostApi(
      `EmployeeReg/UpsertEmployee`,
      payload,
      callbackFun,
      "msg",
      getLogout,
      true,
    );
  };

  const upsertEmployeeWithQuery = (formData, callbackFun) => {
    message.loading("Please Wait...", 0);
    const endpoint = `EmployeeReg/UpsertEmployee`;

    httpClient
      .post(endpoint, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(({ data }) => {
        message.destroy();
        if (data?.IsSuccessfull && data?.StatusCode === 200) {
          callbackFun && callbackFun(data.Message || "Saved successfully");
        } else {
          message.error(data?.Message || "An error occurred");
        }
      })
      .catch((error) => {
        message.destroy();
        if (
          error?.response?.data?.message ===
            "Session has expired. Please log in again." ||
          error?.response?.data?.message === "Token has expired."
        ) {
          message.warn(error.response.data.message);
          getLogout();
        } else {
          message.error(
            error?.response?.data?.Message ||
              error.message ||
              "An error occurred",
          );
        }
      });
  };
  // const upsertEmployeeWithQuery = (queryString, formData, callbackFun) => {
  //   message.loading("Please Wait...", 0);
  //   const endpoint = `EmployeeReg/UpsertEmployee?${queryString}`;

  //   httpClient
  //     .post(endpoint, formData)
  //     .then(({ data }) => {
  //       message.destroy();
  //       if (data?.IsSuccessfull && data?.StatusCode === 200) {
  //         callbackFun && callbackFun(data.Message || "Saved successfully");
  //       } else {
  //         message.error(data?.Message || "An error occurred");
  //       }
  //     })
  //     .catch((error) => {
  //       message.destroy();
  //       if (
  //         error?.response?.data?.message ===
  //           "Session has expired. Please log in again." ||
  //         error?.response?.data?.message === "Token has expired."
  //       ) {
  //         message.warn(error.response.data.message);
  //         getLogout();
  //       } else {
  //         message.error(
  //           error?.response?.data?.Message ||
  //             error.message ||
  //             "An error occurred",
  //         );
  //       }
  //     });
  // };

  return {
    addEmployee,
    getEmployee,
    updateEmployee,
    getEmployeePromise,
    getDesignation,
    getGender,
    getMaritalStatus,
    getBloodGroup,
    getReligion,
    getCountries,
    getState,
    getCities,
    upsertEmployee,
    upsertEmployeeWithQuery,
    getAllEmployees,
    getEmployeeDetail,
    allEmployeesData,
    setAllEmployeesData,
    onUpdateEmployee,
    getData,
    getDoctorPromise,
    getPatientVisits,
  };
};
